import { Column, Entity, Index, JoinColumn, ManyToOne } from 'typeorm';
import { BaseEntity } from './base.entity';
import { CompanyEntity } from './company.entity';
import { ItemEntity } from './item.entity';

@Index('fk_company__id', ['fkCompanyId'], {})
@Index(
	'item_company_fkItemId_deletedUserId_fkCompanyId',
	['deletedUserId', 'fkItemId', 'fkCompanyId'],
	{},
)
@Index(
	'item_company_itemExternalId_deletedDate',
	['itemExternalId', 'deletedDate'],
	{},
)
@Index('idx_item_company_item_deleted', ['fkItemId', 'deletedDate'], {})
@Entity('item_company')
export class ItemCompanyEntity extends BaseEntity {
	@Column('varchar', { name: 'itemExternalId', nullable: true, length: 64 })
	public itemExternalId!: string | null;

	@Column('int', { name: 'fk_item__id', unsigned: true })
	public fkItemId!: number;

	@Column('int', { name: 'fk_company__id', unsigned: true })
	public fkCompanyId!: number;

	@ManyToOne(() => ItemEntity, (item) => item.itemCompanies, {
		onDelete: 'RESTRICT',
		onUpdate: 'RESTRICT',
	})
	@JoinColumn([{ name: 'fk_item__id', referencedColumnName: 'id' }])
	public item!: ItemEntity;

	@ManyToOne(() => CompanyEntity, (company) => company.itemCompanies, {
		onDelete: 'RESTRICT',
		onUpdate: 'RESTRICT',
	})
	@JoinColumn([{ name: 'fk_company__id', referencedColumnName: 'id' }])
	public company!: CompanyEntity;
}
